// extracted by mini-css-extract-plugin
export var backdropBlur = "_mw-0";
export var contentCard = "_mw-5";
export var frame = "_mw-2";
export var image = "_mw-4";
export var imagePane = "_mw-3";
export var modal = "_mw-1";